.container {
  margin: 32px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.icon {
  width: 100%;
  max-width: 500px;
  height: auto;
}

.heading {
  margin-bottom: 64px;
}
